import { MockedRequest, setupWorker, SetupWorkerApi } from 'msw';

import { handlers } from '~/configs/mock/handlers';
import { BASE_URL, SERVICE_PLATFORM_BASE_URL } from '~/utils/appInfo';

export const initMSW = () => {
  const serviceWorker: SetupWorkerApi = setupWorker(...handlers());
  serviceWorker.start({ onUnhandledRequest: warnOnUnhandledRequest });
};

/**
 * handler 에 추가되지 않은 request 를 감지해 warning 을 생성해준다.
 */
function warnOnUnhandledRequest(request: MockedRequest) {
  // 아래 나열된 API server 로의 요청에 대해서만 handling 한다.
  if (
    request.url.origin === BASE_URL ||
    request.url.origin === SERVICE_PLATFORM_BASE_URL
  ) {
    console.warn(
      "'mock/handlers.ts' 에 등록되지 않은 request 가 있습니다.",
      `\nurl: ${request.url.href}`
    );
  }
}
